import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAppAuthContext } from '../utils/AppAuthContext';


import LoginOiDCPage from '../pages/login/LoginOiDCPage';
 

import LogoutPage from '../pages/login/LogoutPage';



import ApplicationPage from '../pages/ApplicationPage';

import ApplicationListPage from '../pages/ApplicationListPage';
import ApplyCancelPage from '../pages/ApplyCancelPage';
import ApplyPage from '../pages/ApplyPage';
import ApplyReSchedultePage from '../pages/ApplyReSchedultePage';
import ApplyViewPage from '../pages/ApplyViewPage';




import VisitorPage from '../pages/VisitorPage';

import VisitorDetailPage from "../pages/VisitorDetailPage";
import VisitorEditPage from "../pages/VisitorEditPage";
import VisitorListPage from "../pages/VisitorListPage";

//Access Log
import AuditLogPage from "../pages/accesslogs/AuditLogPage";
import CourierAccessLogPage from "../pages/accesslogs/CourierAccessLogPage";
import InquiryVisitorPage from "../pages/accesslogs/InquiryVisitorPage";
import VisitorAccessLogPage from "../pages/accesslogs/VisitorAccessLogPage";



//Admin
import ReasonPage from "../pages/admin/ReasonPage";
import UserPage from "../pages/admin/UserPage";
import VipHostPage from "../pages/admin/VipHostPage";




//Reports
// import Report1 from "../pages/reports/Report1";
// import Report2 from "../pages/reports/Report2";
//import Report3 from "../pages/reports/Report3";

import PendingRequestApprovePage from '../pages/request/PendingRequestApprovePage';
import PendingRequestDenyPage from '../pages/request/PendingRequestDenyPage';
import PendingRequestListPage from '../pages/request/PendingRequestListPage';
import PendingRequestPage from '../pages/request/PendingRequestPage';

import PassListPage from '../pages/passes/PassListPage';
import PassPage from '../pages/passes/PassPage';
import HomePage from "../pages/HomePage";
import AboutPage from "../pages/admin/AboutPage";


//import White from '../pages/login/White' 

const RequireAuth=({ children })=> {
   const { loginComplete} = useAppAuthContext()
   const location = useLocation();
 
    return (
      <>
      {!loginComplete && 
      
        <Navigate to="/" state={{ from: location }} />
      }
      {
        loginComplete && 
        children
      }
      </>
    )


 }


//  const DiscardAuth=({ children })=> {

//    const {userInfo, loginComplete, logout} = useAppAuthContext()

//    const location = useLocation();
 
//    useEffect(  ()=>{
//       if (loginComplete) 
//       {
//           //logout()
//       }
         
//    },[])
//    return children;
//  }

 const HomeOrLoingPage=()=> {

   const {loginComplete} = useAppAuthContext()

   return (
    <>
    {loginComplete && 
    
      <HomePage/>
    }
    {
      !loginComplete && 
      <LoginOiDCPage/>
    }
    
    </>
  )
   
 }



const AuthRoutes =() =>{
 
return(
    <Routes>
        
        {/** 
        <Route path="/login" element={<DiscardAuth><LoginPage/></DiscardAuth>}/>
        */}
        <Route path="/logout" element={<LogoutPage/>}/>

        <Route path="/login_oidc" element={<LoginOiDCPage/>}/>

        
        {/** <Route path="/profile" element={<White/>}/>  */}
      
        <Route path="/" element={<HomeOrLoingPage/>  }/>
        
        
        
        

        
        <Route path="/invite_visitor/:visitor_id" 
               element={<RequireAuth><ApplyPage action={'invite'}/></RequireAuth>}/>
        <Route path="/invite_invitation/:invitation_id" 
               element={<RequireAuth><ApplyPage action={'reinvite'}/></RequireAuth>}/>

        
        {/** 
            <Route path="/invite_query" element={<RequireAuth><ApplicationListPage/></RequireAuth>}/>
            <Route path="/invite_query_detail/:id" element={<RequireAuth><ApplyViewPage/></RequireAuth>}/>

            <Route path="/invite_edit/:invitation_id" 
               element={<RequireAuth><ApplyPage action={'edit'}/></RequireAuth>}/>
        

       */}

        <Route path="/invitations" element={<RequireAuth><ApplicationPage/></RequireAuth>}>
               <Route index element={<RequireAuth><ApplicationListPage/></RequireAuth>}/>
        
               <Route path="invite" element={<RequireAuth><ApplyPage action={'create'}/></RequireAuth>}/>
        
               <Route path="view/:id" element={<RequireAuth><ApplyViewPage/></RequireAuth>}/>
               <Route path="reinvite/:invitation_id"  element={<RequireAuth><ApplyPage action={'reinvite'}/></RequireAuth>}/>

               <Route path="cancel/:id" element={<RequireAuth><ApplyCancelPage action="Cancel"/></RequireAuth>}/>
               <Route path="delete/:id" element={<RequireAuth><ApplyCancelPage action="Delete"/></RequireAuth>}/>


               <Route path="reschedule/:id" element={<RequireAuth><ApplyReSchedultePage/></RequireAuth>}/>
               
        
        </Route>



         {/** Visitors */}
       

         <Route path="/visitor"element={<RequireAuth><VisitorPage /></RequireAuth>}>
            <Route index element={<VisitorListPage />}/>
            <Route path="create" element={<VisitorEditPage action={'create'}/>} />
            <Route path="view/:id" element={<VisitorDetailPage />} />
            <Route path="edit/:id" element={<VisitorEditPage action={'edit'}/>} />
         </Route>
    
         <Route path="/request" element={<RequireAuth><PendingRequestPage /></RequireAuth>}>
           <Route index element={<RequireAuth><PendingRequestListPage /></RequireAuth>}/>
           <Route path='approve/:id' element={<RequireAuth><PendingRequestApprovePage /></RequireAuth>}/>
           <Route path='deny/:id' element={<RequireAuth><PendingRequestDenyPage /></RequireAuth>}/>
         </Route>

         <Route path="/pass" element={<RequireAuth><PassPage /></RequireAuth>}>
           <Route index element={<RequireAuth><PassListPage /></RequireAuth>}/>
         </Route>

         
         {/** 
         <Route path='/visitor/create' element={<RequireAuth><VisitorEditPage action={'create'}/></RequireAuth>}     />

         <Route path='/visitor/inquery' element={<RequireAuth><SearchVisitorView/></RequireAuth>}/>
         */}
         

        
         
         <Route path="/access/visitors" element={<RequireAuth><VisitorAccessLogPage/></RequireAuth>}/>
         <Route path="/access/couriers" element={<RequireAuth><CourierAccessLogPage/></RequireAuth>}/>
         <Route path="/access/auditlog" element={<RequireAuth><AuditLogPage/></RequireAuth>}/>
        
         <Route path="/access/visitor_inquiry" element={<RequireAuth><InquiryVisitorPage/></RequireAuth>}/>
        
         <Route path="/access/visitor_inquiry" element={<RequireAuth><InquiryVisitorPage/></RequireAuth>}/>



         <Route path="/admin/reason" element={<RequireAuth><ReasonPage/></RequireAuth>}/>
         <Route path="/admin/viphost" element={<RequireAuth><VipHostPage/></RequireAuth>}/>
         <Route path="/admin/user" element={<RequireAuth><UserPage/></RequireAuth>}/>
         <Route path="/admin/about" element={<RequireAuth><AboutPage/></RequireAuth>}/>
         

         {/** 
        <Route path="/reports/report1" element={<RequireAuth><Report1/></RequireAuth>}/>
        <Route path="/reports/report2" element={<RequireAuth><Report2/></RequireAuth>}/>
        */}
       
          
      </Routes>
   ) 
}

export default AuthRoutes